import { Card, CardBody, CardExpandToggler } from '../../../components/card/card.jsx';
// import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Bar from '../../dashboard/Bar.jsx';
import { useTranslation } from 'react-i18next';

const EmployeeByOrg = () => {
  const { t, i18n } = useTranslation();

  const { Employees } = useSelector((state) => state.Employees);

  function countEmployeesByOrganizationId(employees) {
    const organizationCount = {};

    employees?.forEach((employee) => {
      const orgId = employee.organizatioN_ID;
      const orgName = employee.organizatioN_NAME;
      if (organizationCount[orgId]) {
        organizationCount[orgId].count++;
      } else {
        organizationCount[orgId] = {
          organizatioN_ID: orgId,
          name: orgName,
          count: 1,
        };
      }
    });

    // تحويل النتيجة إلى مصفوفة من الكائنات
    const result = Object.values(organizationCount);

    return result;
  }

  const [data, setData] = useState([]);

  useEffect(() => {
    const generatedData = countEmployeesByOrganizationId(Employees);
    setData(generatedData);
  }, [Employees]);

  return (
    <div>
      <Card className="mb-3" style={{ height: '100%' }}>
        <CardBody className="">
          <div className="d-flex fw-bold small mb-3">
            <span className="flex-grow-1">{t('EmployeesByDepartment')}</span>
            <CardExpandToggler />
          </div>

          <Bar
            categories={data?.map(
              (item) => item?.name || (i18n.language === 'en' ? 'Undefined' : 'غير محدد')
            )}
            series={[
              {
                name: t('employee'),
                data: data?.map((item) => item?.count || 0),
              },
            ]}
            height={400}
            isStacked
          />
        </CardBody>
      </Card>
    </div>
  );
};

export default EmployeeByOrg;
